import { Tooltip } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { EntityClass } from '../../../../../types';
import { JupiterTheme } from '../../../../theme/types';
import Tile from './Tile';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    tooltip: {
      maxWidth: '300px',
      padding: theme.spacing(2),
    },
    container: {
      background: theme.palette.grey[100],
      borderRadius: 2,
      boxShadow: '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
      color: theme.palette.coolGrey[200],
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'column',
      height: '112px',
      overflow: 'hidden',
      paddingTop: theme.spacing(0.5),
      position: 'relative',
      textAlign: 'center',
      width: 200,
    },
    containerActive: {
      cursor: 'pointer',
      color: theme.palette.primary.dark,
      '&:before': {
        background: theme.palette.primary.main,
        borderRadius: 3,
        bottom: -2,
        content: `''`,
        display: 'block',
        height: 5,
        position: 'absolute',
        width: 0,
      },
      '&:hover': {
        background: `rgba(255, 255, 255, .6)`,
        transition: '0.25s ease-in-out',
        '& svg': {
          color: theme.palette.primary.dark,
        },
        '&:before': {
          transition: '.2s ease-out',
          width: '80%',
        },
      },
    },
  })
);

export interface ClassTile {
  name: string;
  classSchema: EntityClass;
  disabled?: boolean;
  onSelect: (selectedClass: EntityClass, name: string) => void;
}

const ClassTile = ({
  name,
  classSchema,
  disabled = false,
  onSelect,
}: ClassTile) => {
  const classes = useStyles();

  const handleSelect = () => {
    if (!disabled) onSelect(classSchema, name);
  };

  return (
    <Tooltip
      title={!disabled ? classSchema.description : ''}
      classes={{ tooltip: classes.tooltip }}
      enterDelay={500}
      placement="top"
    >
      <div
        onClick={handleSelect}
        className={clsx(
          classes.container,
          !disabled && classes.containerActive
        )}
      >
        <div>
          <Tile className={name} disabled={disabled} />
        </div>
        <div>{name}</div>
      </div>
    </Tooltip>
  );
};

export default ClassTile;
